import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Ellipse, Path } from "react-native-svg";

export const IconGlobe2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGlobe2"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Ellipse cx="12" cy="12" rx="3.5" ry="9.5" stroke="currentColor"/><Path d="M3 9H21" stroke="currentColor"/><Path d="M3 15H21" stroke="currentColor"/></CentralIconBase>;
});

export default IconGlobe2;
